import { ProductBlueprintVisibilityDTO } from '../DTOs/ProductBlueprintVisibilityDTO';

export class ProductBlueprintVisibility {
  visibleToAdmin: boolean | null;

  public static fromDTO(productBlueprintVisibilityDTO: ProductBlueprintVisibilityDTO) {
    return new ProductBlueprintVisibility(productBlueprintVisibilityDTO.visibleToAdmin);
  }

  constructor(visibleToAdmin: boolean | null) {
    this.visibleToAdmin = visibleToAdmin;
  }
}
